import { useNotifications } from '@/core/Notifications/store';

export default useNotifications;
